/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

const CARD_WIDTH = '284px';

export const sxStyles = {
  logoCover: {
    paddingTop: '20px',
    height: '157px',
    width: CARD_WIDTH,
  },
  title: {
    fontSize: '1.5rem',
    minHeight: '64px',
    padding: '0rem 1rem 1rem 1rem',
  },
  subtitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '266%',
    textTransform: 'uppercase',
    padding: '1rem 1rem 0.5rem 1rem',
  },
  description: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '130%',
    padding: '0rem 1rem 1rem 1rem',
    minHeight: '100px',
  },
  containerButtons: {
    padding: '1rem',
  },
  favoriteBtn: (theme: Theme) => ({
    width: '100%',
    padding: '0.75rem',
    borderRadius: '40px',
    color: theme.palette.primary.main,

    '&:hover': {
      background: theme.palette.grey[100],
    },
  }),
};

export const StyledContainerLink = styled('a')(() => ({
  textDecoration: 'none',

  '&:hover': {
    cursor: 'pointer',
  },
}));

export const StyledCard = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '12px',
  color: theme.palette.common.black,
  maxWidth: CARD_WIDTH,
  position: 'relative',
  width: '100%',
  boxShadow: `0px 8px 24px -4px ${theme.palette.divider}`,
  transition: 'box-shadow 0.5s',

  '&:hover': {
    boxShadow: `0px 8px 32px -4px ${theme.palette.divider}`,
  },
}));

export const StyledLogo = styled('img')(() => ({
  aspectRatio: '2/1',
  blockSize: 'auto',
  height: '100%',
  maxInlineSize: '100%',
  objectFit: 'fill',
  borderRadius: '12px 12px 0 0',
}));

export const StyledCardInfo = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: '144px',
  paddingTop: '2.5rem',
}));
